<script lang="ts">
  import type { AssetField } from "$types/components";
  import { beforeUpdate } from "svelte";

  export let media: AssetField;
  export let aspect:
    | "auto"
    | "square"
    | "video"
    | "portrait"
    | "16-9"
    | undefined = undefined;
  export let aspectMd: "auto" | "square" | "video" | "portrait" | undefined =
    undefined;

  let videoEl: HTMLVideoElement;

  function getAspect() {
    let aspectClass = "";
    if (aspect) {
      aspectClass += `aspect-${aspect}`;
    }
    if (aspectMd) {
      aspectClass += ` md:aspect-${aspect}`;
    }
    return aspectClass;
  }

  beforeUpdate(() => {
    if (videoEl && !videoEl.paused) {
      videoEl.pause();
    }
  });
</script>

<div
  class={`video ${aspect ? "object-cover" : null} ${getAspect()} ${
    $$props.class || ""
  }`}
>
  <video
    autoplay
    muted
    playsinline
    loop
    bind:this={videoEl}
    src={media.filename}
  ></video>
</div>

<style lang="postcss">
  .video {
    overflow: hidden;
    border-radius: 6px;
    background: rgb(var(--color-warm-grey));
    height: 100%;
  }

  video {
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }
</style>
